// extracted by mini-css-extract-plugin
module.exports = {"Image":"Picture__Image_ZOj6J","Logo":"Picture__Logo_31YVL"};